<template lang="pug">
  include /mixins
  +b.slider-box.--free.relative
    +b.category-swipe-wrapper.--variant_common.fake-slider
      +e.cell.--variant_5(
        v-for="item in info.props.ambassador_recommends"
      )
        ui-story-video-card(:item="item")
    +b.t-controls.--space_top.--variant_common.snap-controls(
      :data-count="info.props.ambassador_recommends.length"
    )
      +e.item.is-disabled(
        data-snap-slider-goto="right" :aria-label="_('Следующий слайд')"
      )
        +b.mdi.mdi-chevron-left
      +e.item(
        data-snap-slider-goto="left" :aria-label="_('Предыдущий слайд')"
      )
        +b.mdi.mdi-chevron-right
</template>

<script>
import sliderControl from '@utils/slider-controls'

export default {
  props: {
    info: {
      type: Object,
    },
  },

  async created() {
    await this.$nextTick()

    sliderControl('js-ajax-slider-box')
  },
}
</script>
